import { useEffect, useState } from "react"
import { SchedulePlanScreen } from "../../screen/SchedulePlanScreen"
import { customToast } from "../../components/Toast"
import Send from "../../core/communication"
import { useChatContext } from "../../core/context/chatContext"
import { useSelector } from "react-redux"
import { fixJsonString } from "../../core/utils/fixJsonString"

const inputList = [
  {
    type: ["text", "date"],
    title: ["Dê um título para o atendimento", "Quando será realizado?"],
    isRequired: [true, true],
    col: 1,
  },
  {
    type: "textarea",
    title: "Qual é o principal desafio ou problema? (Motivo do atendimento)",
    isRequired: true,
    col: 1,
  },
  {
    type: "select",
    title: "Qual cultura está apresentando o problema?",
    isRequired: false,
    col: 1,
    formQuestionId: "3f263403-7a5e-49b4-a39f-df22e26b164a",
  },
  {
    type: "select",
    title: "Quais outras culturas estão presentes na propriedade?",
    isRequired: false,
    col: 1,
    formQuestionId: "37705b97-6541-4a27-80ef-e166a6f3dd86",
  },
  {
    type: "select",
    title: "Qual o tipo de agricultura praticada?",
    isRequired: false,
    col: 1,
    formQuestionId: "a9ece14c-0cc8-4487-b376-bd07de4baf64",
  },
  // {
  //   type: 'file',
  //   title: 'Anexe uma foto do problema',
  //   isRequired: false,
  //   col: 1,
  //   formQuestionId: '29e88e99-1796-467a-9434-b53bf3f3e464',
  // },
  {
    type: "textarea",
    title: "Descreva os sintomas que observa na planta",
    isRequired: false,
    col: 2,
    formQuestionId: "963a965f-8105-412d-ab71-c8710400c69f",
  },
  {
    type: "select",
    title: "Foi realizado algum manejo para tentar controlar o problema?",
    isRequired: false,
    col: 2,
    formQuestionId: "01092c11-e208-4afa-b1f1-7a6e2aec8d89",
  },
  {
    type: "select",
    title: "Foi feita alguma adubação recentemente?",
    isRequired: false,
    col: 2,
    formQuestionId: "dc01204b-8d10-4e06-b351-70e270409567",
  },
  {
    type: "select",
    title: "Como está a irrigação?",
    isRequired: false,
    col: 2,
    formQuestionId: "14b28b18-c2db-4582-8fe0-852038955a66",
  },
  {
    type: "textarea",
    title: "Observações (histórico da área; insumos utilizados; etc)",
    isRequired: false,
    col: 2,
    formQuestionId: "4949256e-95a1-41a4-a023-3c85ea08d7f0",
  },
]

const loadAllTec = async (setTechnicalList, loggedUser) => {
  try {
    const response = await Send.get("/users/tec-or-manager")

    setTechnicalList([
      { value: loggedUser?.id, label: loggedUser?.name },
      ...response.map((row) => ({ value: row?.id, label: row?.name })),
    ])
  } catch (error) {
    console.log("Error => ", error)
    customToast("Erro ao carregar técnicos", "error")
  }
}

const loadFormOptions = async (setFormattedInputList) => {
  try {
    const response = await Send.post("/questions-options/form-question", {
      formQuestionIds: inputList.map((row) => row.formQuestionId).filter((row) => row),
    })

    if (!response || !Array.isArray(response) || !response.length) {
      throw new Error(response)
    }

    const newInputList = inputList.map((row) => {
      if (!row.formQuestionId) {
        return row
      }

      const options = response.find((item) => item.id === row.formQuestionId)?.options

      return options && options.length
        ? { ...row, options: options.map((opt) => ({ value: opt, label: opt })) }
        : row
    })

    setFormattedInputList(newInputList)
  } catch (error) {
    customToast("Erro ao carregar formulário.", "error")
    console.log("Error => ", error)
  }
}

export const SchedulePlanContainer = ({ hasMessage = true, users: farmers, callback }) => {
  const { user: loggedUser } = useSelector((state) => state.app.user)
  const {
    pinnedMessages: pinnedMessage,
    handleCloseSchedule,
    resetPinnedMessages,
  } = useChatContext()
  const [currentStep, setCurrentStep] = useState(1)
  const [formattedInputList, setFormattedInputList] = useState(inputList)
  const [technicalList, setTechnicalList] = useState([])
  const [values, setValues] = useState({})
  const [loading, setLoading] = useState(false)
  const [loadingIA, setLoadingIA] = useState(false)
  const [selectedProject, setSelectedProject] = useState(null)

  useEffect(() => {
    loadFormOptions(setFormattedInputList)
    loadAllTec(setTechnicalList, loggedUser)
  }, [])

  const generateByIA = async () => {
    try {
      setLoadingIA(true)
      const response = await Send.post("/ia/ask", {
        question: `Você é um agrônomo e está identificando a necessidade do produtor, com base nestas mensagens vindas do chat do produtor, mostre-me o json para criar a demanda no sistema, segue as mensagens: ${JSON.stringify(
          pinnedMessage.map((item) => ({ user: item.user, content: item.content })),
        )} `,
        context: `Este é um json utilizado para fazer um post no meu backend para gerar demandas, gere sempre um body equivalente: ${iaContext}`,
      })

      if (response && response.message && response.message.content) {
        // Usando regex para extrair o JSON do texto
        const jsonExtract = response.message.content.split("```json")[1]?.split("```")[0]?.trim()

        if (!jsonExtract) {
          throw new Error("Formato de JSON não encontrado no texto")
        }

        const result = fixJsonString(jsonExtract)

        setValues(result?.context)
      }
    } catch (error) {
      console.log("error", error)
      customToast("Erro ao gerar agendamento baseado em ia, tente novamente", "error")
    }

    setLoadingIA(false)
  }

  const goToNextStep = () => {
    setLoading(true)
    if (
      !values["Dê um título para o atendimento"] ||
      !values["Quando será realizado?"] ||
      !values["Qual é o principal desafio ou problema? (Motivo do atendimento)"] ||
      (farmers && Array.isArray(farmers) && farmers[0]?.projectIds?.length > 1 && !selectedProject)
    ) {
      customToast("Você deve preencher todas as informações obrigatórias!", "warning")
      setTimeout(() => {
        setLoading(false)
      }, 1000)
      return
    }

    setCurrentStep(currentStep + 1)
    setTimeout(() => {
      setLoading(false)
    }, 1000)
  }

  const goToPreviousStep = () => {
    setLoading(true)
    setCurrentStep(currentStep - 1)
    setTimeout(() => {
      setLoading(false)
    }, 1000)
  }

  const goToFarmerProfile = () => {
    handleCloseSchedule()
  }

  const handleSaveSchedule = async () => {
    if (!values["tec"]) {
      customToast("Você deve selecionar o técnico responsável.", "warning")
      return
    }

    console.log("FARMERS", farmers)

    try {
      setLoading(true)

      for (let index = 0; index < farmers.length; index++) {
        const farmer = farmers[index]

        const response = await Send.post("/events-sector/schedule-context", {
          title: values["Dê um título para o atendimento"],
          description: values["Qual é o principal desafio ou problema? (Motivo do atendimento)"],
          dataToUpdate: {
            dateToAdd: values["Quando será realizado?"],
          },
          producerId: farmer.id,
          responsible: loggedUser?.id,
          technician: values["tec"],
          context: values,
          pinnedMessage,
          project: selectedProject?.value || farmer?.projectId,
        })

        if (response?.status !== "success") {
          throw new Error(response)
        }
      }

      customToast("O atendimento foi agendado com sucesso.", "success")
      setTimeout(() => {
        setLoading(false)
      }, 1000)
      if (handleCloseSchedule) {
        handleCloseSchedule()
      }

      if (resetPinnedMessages) {
        resetPinnedMessages()
      }

      if (callback) {
        callback()
      }
    } catch (error) {
      console.log("Error -> ", error)
      customToast("Erro ao agendar atendimento. Entre em contato com o suporte.", "error")
      setLoading(false)
    }
  }

  const handleChange = (inputType, name, value) => {
    if (inputType === "file") {
      return
    }

    setValues((curr) => ({ ...curr, [name]: value }))
  }

  const handleSelectProject = (field) => {
    setSelectedProject(field)
  }

  return (
    <SchedulePlanScreen
      {...{
        inputList: formattedInputList,
        currentStep,
        goToNextStep,
        goToPreviousStep,
        handleSaveSchedule,
        handleChange,
        values,
        pinnedMessage,
        technicalList,
        farmers,
        goToFarmerProfile,
        generateByIA,
        loadingIA,
        handleSelectProject,
        loading,
        hasMessage,
        selectedProject,
      }}
    />
  )
}

const iaContext = `{
    "title": "Titulo do atendimento",
    "description": "Contextualize o motivo do atendimento",
    "dateToAdd": "2024-07-08",
    "context": {
        "Dê um título para o atendimento": "Titulo do atendimento",
        "Quando será realizado?": "2024-07-08",
        "Qual é o principal desafio ou problema? (Motivo do atendimento)": "Contextualize o motivo do atendimento",
        "3f263403-7a5e-49b4-a39f-df22e26b164a": [
            {
                "value": "Mandioca",
                "label": "Mandioca"
            }
        ],
        "37705b97-6541-4a27-80ef-e166a6f3dd86": [
            {
                "value": "Açaí",
                "label": "Açaí"
            }
        ],
        "963a965f-8105-412d-ab71-c8710400c69f": "Se possível, identifique sintomas das plantas ou solo",
        "01092c11-e208-4afa-b1f1-7a6e2aec8d89": [
            {
                "value": "Adubação",
                "label": "Adubação"
            }
        ],
        "dc01204b-8d10-4e06-b351-70e270409567": [
            {
                "value": "Não",
                "label": "Não"
            }
        ],
        "14b28b18-c2db-4582-8fe0-852038955a66": [
            {
                "value": "Possui sistema de irrigação por aspersão ",
                "label": "Possui sistema de irrigação por aspersão "
            }
        ],
        "4949256e-95a1-41a4-a023-3c85ea08d7f0": "Crie uma observação detalhada sobre o atendimento do produtor",
    }
}`
